import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "../data/site";

const LOGO = "/assets/ats-logo.png";
const KEY = "ats-splash-seen";
const ease = [0.22, 1, 0.36, 1];

export const Splash = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    return !sessionStorage.getItem(KEY);
  });

  useEffect(() => {
    if (!show) return;
    document.documentElement.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setShow(false);
    }, 1900);
    return () => {
      clearTimeout(t);
      document.documentElement.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[100] bg-navy-deep flex items-center justify-center overflow-hidden"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 0.7, ease }}
        >
          <div className="absolute w-[520px] h-[520px] rounded-full bg-brand-orange/15 blur-[140px]" />

          <motion.svg
            width="220"
            height="220"
            viewBox="0 0 220 220"
            className="absolute"
            initial={{ rotate: -90 }}
            animate={{ rotate: 270 }}
            transition={{ duration: 1.6, ease }}
          >
            <motion.circle
              cx="110"
              cy="110"
              r="104"
              fill="none"
              stroke="#F26522"
              strokeWidth="2"
              strokeLinecap="round"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 1.2, ease, delay: 0.1 }}
            />
          </motion.svg>

          <motion.img
            src={LOGO}
            alt={`${BRAND.name} logo`}
            data-testid="splash-logo"
            className="relative w-40 h-40 rounded-full object-contain shadow-2xl shadow-black/60"
            initial={{ scale: 0.6, opacity: 0, filter: "blur(8px)" }}
            animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
          />

          <motion.p
            className="absolute bottom-16 font-mono text-[11px] tracking-[0.35em] uppercase text-slate-400"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            {BRAND.name}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Splash;
